import { render, staticRenderFns } from "./rt.vue?vue&type=template&id=4054622b"
import script from "./rt.vue?vue&type=script&lang=js"
export * from "./rt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports